import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "homeScreen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Reset your password", -1)

import ResetPassword from '@/components/auth/ResetPassword.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ResetPassword)
  ]))
}
}

})